import { useState } from "react";
import { fullName } from "../../helperfunctions/helperfunctions";
import { handleData } from "../../api";
import AdminNewOrEditTaak from "./AdminNewOrEditTaak";


const AdminTaak = (props) => {

    const { taak, activiteitID, closeActiviteitForm } = props;
    const { _id, taaknaam, taakomschrijving, dagdeel } = taak;

    const initialEditStatus = {
        taakEdit: false,
        taakEditID: ""
    }
    const [editStatus, setEditStatus] = useState(initialEditStatus);

    // taak verwijderen
    const handleDeleteTaak = async () => {
        const path = `activiteiten/${activiteitID}/verwijdertaak/${_id}`;
        const data = {
            method: 'PATCH',
            path: path,
            input: ""
        }
        const result = await handleData(data);
        closeActiviteitForm(true);
    }

    const handleEditTask = () => {
        setEditStatus({
            ...editStatus,
            taakEdit: true,
            taakEditID: _id
        })
    }

    const vrijwilligersNaam = taak.vrijwilliger ? fullName(taak.vrijwilliger) : "";
    const contactpersoonNaam = taak.contactpersoon ? fullName(taak.contactpersoon) : "";

    return (
        <>
            <div className='adminTaakContainer'>
                <div className='taakTop'>
                    <p>{taaknaam}</p>
                    <div className='buttons'>
                        <button onClick={handleDeleteTaak}>X</button>
                        <button onClick ={handleEditTask}>Edit</button>
                    </div>
                </div>
                <div className='taakBody'>
                    <div className='taakField'>
                        <p>Taakinfo: </p>
                        <p>{taakomschrijving || "--"}</p>
                    </div>
                    <div className='taakField'>
                        <p>Dagdeel: </p>
                        <p>{dagdeel || "--"}</p>
                    </div>
                    <div className='taakField'>
                        <p>Contactpersoon: </p>
                        {taak.contactpersoon ? <p>{contactpersoonNaam}</p> : <p>--</p>}
                    </div>
                    <div className="taakField">
                        <p>Vrijwilliger:</p>
                        {taak.vrijwilliger ? <p>{vrijwilligersNaam}</p> : <p>--</p>}
                        {taak.vrijwilliger && (taak.bevestigd ? <p>(bevestigd)</p> : <p>(nog niet bevestigd)</p>)}

                    </div>    
   
                    
                </div>
                {(editStatus.taakEdit && editStatus.taakEditID === _id) &&
                    <div className='editTaskContainer'>
                        <hr />
                        <AdminNewOrEditTaak 
                            taak={taak} 
                            activiteitID={activiteitID} 
                            mode="edit"
                            setEditStatus={setEditStatus}
                            closeActiviteitForm={closeActiviteitForm}
                        />
                    </div>
                } 
            </div>
        </>
    );
}

export default AdminTaak;